import React, { useState, useEffect, useRef } from 'react'
import { FilterMatchMode, FilterOperator } from 'primereact/api'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { InputText } from 'primereact/inputtext'
import { Button } from 'primereact/button'
import States from '../../../components/generals/states.js'
import store from '../../../reducer/store'
import CheckErrorLog from '../../modals/modalsRxartSecure/components/checkErrorLogs.js'
import ActionDashboard from './actionDashboard'
import NavLinkButton from './navlinkButton..js'
import ActionDelete from './actionDelete'
import ActionOptionsMenuGeofence from './actionOptionsMenuGeofence.js'
import ModifyListSafe from './modifyListSafe.js'
import PropTypes from 'prop-types'
import '../../../css/generals/dataTable.css'
import ActionOptionsMenuBlockCases from './actionOptionsMenuBlockCases.js'
import { popupSimple } from '../popups.js'
import { useTranslation } from 'react-i18next'
// import JsPDF from 'jspdf'
// import autoTable from 'jspdf-autotable'
import { postData } from '../../../actions/servicesHttp.js'
import { useNavigate } from 'react-router-dom'

export default function DataTableDemo ({
  searchs,
  table,
  type,
  onSelecteds,
  selected,
  editDataUser,
  actionBtn,
  actionBlockCases,
  actionDenunciation,
  titleBtn,
  reload,
  title,
  header,
  showMenu,
  getFence,
  exportsCsv,
  exportsPdf,
  rowSelecteds,
  rowStates,
  actionDashboard,
  actionDelete,
  optionsMenu,
  modifyLists,
  viewBtnAction,
  columns,
  data,
  editUsers,
  link,
  informationOptionMenu,
  editOptionMenu,
  columnStatus,
  namePdf,
  renderHeaderDenunciations
}) {
  const { user } = store.getState()
  const { t, i18n } = useTranslation('dataTableDemo')
  const navigate = useNavigate()
  const dt = useRef(null)
  const [customers, setCustomers] = useState(data)
  const [selectedCustomers, setSelectedCustomers] = useState(null)
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    [searchs[0]]: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
    }
  })

  const [globalFilterValue, setGlobalFilterValue] = useState('')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setCustomers(data)
    setLoading(false)
    if (table !== 'roles') { setSelectedCustomers(null) } else if (selected?.length > 0) { setSelectedCustomers(selected) }
  }, [data, table])

  const onGlobalFilterChange = (e) => {
    const value = e.target.value
    const _filters = { ...filters }
    _filters.global.value = value

    setFilters(_filters)
    setGlobalFilterValue(value)
  }

  const selecteds = (data) => {
    setSelectedCustomers(data)
    if (table !== 'keyWords') onSelecteds(data, table)
  }

  const states = (rowData) => {
    const typeColumn = columnStatus.find((col) => col.field === 'type')
    const statusLockColumn = columnStatus.find((col) => col.field === 'status_lock')
    return (
      <States
        alert={rowData.stat}
        title={statusLockColumn !== undefined
          ? rowData.status_lock === true
            ? 'Bloqueado'
            : rowData.status_lock === false || rowData.status_lock === null
              ? 'Desbloqueado'
              : 'Desconocido'
          : 'Desconocido'
        }
        type={typeColumn !== undefined ? rowData.type : undefined}
      ></States>
    )
  }

  const editUser = (rowData) => {
    return (
      <Button
        icon="fa-solid fa-pen-to-square"
        className="p-button-rounded p-button-success btn-white"
        aria-label="Search"
        tooltip={t('tooltip1')}
        tooltipOptions={{ position: 'top' }}
        onClick={() => editDataUser(rowData)}
      />
    )
  }

  const btn = (rowData) => {
    return (
        <Button
          className="p-button-secondary"
          onClick={() => actionBtn(rowData)}
        >
          {titleBtn}
        </Button>
    )
  }

  const optionsMenuBlockCases = (rowData) => {
    return (
      <ActionOptionsMenuBlockCases
        actionTracking={() => actionBlockCases(rowData)}
        options={{ trackingOptionMenu: true, denunciationOptionMenu: true }}
        trackingId={rowData.trackingId}
        actionDenunciation={() => actionDenunciation(rowData)}
      ></ActionOptionsMenuBlockCases>
    )
  }

  const navLink = (rowData) => {
    return (
      <NavLinkButton
        title={table === 'cases' ? t('button1') : null}
        url={`gallery/${rowData.id}`}
      />
    )
  }

  const dashboard = (rowData) => {
    return (
      <ActionDashboard
        type={table === 'devices' ? 'device' : 'group'}
        id={rowData.id}
      ></ActionDashboard>
    )
  }

  const deleted = (rowData) => {
    return (
      <ActionDelete
        id={rowData.id}
        table={table}
        reload={reload}
      ></ActionDelete>
    )
  }

  const modifyListsSW = (rowData) => {
    return (
      <ModifyListSafe data={rowData} reload={reload}></ModifyListSafe>
    )
  }

  const optionsMenuGeofence = (rowData) => {
    return (
      <ActionOptionsMenuGeofence
        id={rowData.id}
        table={table}
        onShowModal={showMenu}
        onGetFence={getFence}
        informationOptionMenu={informationOptionMenu}
        editOptionMenu={editOptionMenu}
      ></ActionOptionsMenuGeofence>
    )
  }

  const exportCSV = (selectionOnly) => {
    popupSimple('info', t('message1'))
    dt.current.exportCSV({ selectionOnly })
  }

  const exportPdf = async (cols, data, namePdf) => {
    popupSimple('info', t('message1'))

    const colsJson = cols.map(obj => [obj.header, obj.field])

    const json = {
      title: namePdf,
      columnName: colsJson,
      data
    }

    const handleDownload = async (url, namePdf) => {
      try {
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/pdf'
          }
        })

        if (!response.ok) {
          throw new Error('Error al descargar el archivo')
        }

        const blob = await response.blob()
        const blobUrl = window.URL.createObjectURL(blob)

        const link = document.createElement('a')
        link.href = blobUrl
        link.setAttribute('download', `${namePdf}.pdf`)
        document.body.appendChild(link)
        link.click()
        link.remove()

        window.URL.revokeObjectURL(blobUrl)
      } catch (error) {
        console.error('Error en la descarga:', error)
      }
    }

    const res = await postData('process-pdf', json, navigate)
    if (res?.status === 200) {
      handleDownload(res.data.url, namePdf)
    } else {
      popupSimple('error', t('message2'))
    }
  }

  const renderHeader = () => {
    return (
      <div
        className={
          header === 'column' ? 'headerTableColumn' : 'headerTable'
        }
      >
        <h3 className="m-0">{title}</h3>
        <div className="containerHeader">
          <div className="buttonExtract">
            {exportsCsv === false
              ? null
              : (
              <Button
                type="button"
                icon="pi pi-file"
                onClick={() => exportCSV(false)}
                className="mr-2"
                data-pr-tooltip="CSV"
                tooltip="CSV"
                tooltipOptions={{ position: 'top' }}
              />
                )}
                {exportsPdf === false
                  ? null
                  : ((table === 'deviceHardwareReport' || table === 'establishments' || table === 'missingDevicesReport' || table === 'reportedDevicesReport' || table === 'devicesLocationReport' || table === 'devicesReport' || table === 'deviceActivationReport' || table === 'usersReport' || table === 'geofencesReport' || table === 'allDevicesConnections' || table === 'groups' || table === 'roles' || table === 'appsDevice' || table === 'cases' || table === 'softwareEvents' || table === 'devicesEvents') &&
                    <Button
                      type="button"
                      icon="pi pi-file-pdf"
                      onClick={() => exportPdf(columns, data, namePdf)}
                      className="mr-2"
                      data-pr-tooltip="PDF"
                      tooltip="PDF"
                      tooltipOptions={{ position: 'top' }}
                    />
                    )}
          </div>
          <div className="searchContainer">
            <span className="p-input-icon-left">
              <i className="pi pi-search search" />
              <InputText
                value={globalFilterValue}
                onChange={onGlobalFilterChange}
                placeholder={t('placeholder')}
              />
            </span>
          </div>
        </div>
      </div>
    )
  }

  const headerDataTable = table === 'denunciations' ? renderHeaderDenunciations() : renderHeader(namePdf, data, table, table === 'deviceHardwareReport' || table === 'establishments' || table === 'missingDevicesReport' || table === 'reportedDevicesReport' || table === 'devicesLocationReport' || table === 'devicesReport' || table === 'deviceActivationReport' || table === 'usersReport' || table === 'geofencesReport' || table === 'allDevicesConnections' || table === 'groups' || table === 'roles' || table === 'appsDevice' || table === 'cases' ? columns : null, i18n?.language === 'es' ? '¡El proceso de descarga de la tabla en formato PDF puede demorar!' : i18n?.language === 'en' ? 'The process of downloading the table in PDF format may take a while!' : null)
  // const headerDataTable = renderHeader()

  const renderCheckLog = () => <CheckErrorLog />
  const checkDataTableLogs = renderCheckLog()

  return (
    <div className="datatable-doc-demo">
      {table === 'errorLogs' && checkDataTableLogs}
      <div id={ type === 'apps' ? 'tableApps' : '' }>
        <DataTable
          size="small"
          ref={dt}
          exportFilename={namePdf}
          value={customers}
          paginator
          className="p-datatable-customers"
          header={table === 'statusHistoryRS' ? null : table === 'ticketsIssuedRS' ? null : headerDataTable}
          rows={5}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          rowsPerPageOptions={[5, 10, 25, 50]}
          dataKey="id"
          rowHover
          selection={selectedCustomers}
          onSelectionChange={(e) => selecteds(e.value)}
          filters={filters}
          filterDisplay="menu"
          loading={loading}
          responsiveLayout="scroll"
          globalFilterFields={searchs}
          emptyMessage={t('emptyMessage')}
          currentPageReportTemplate={`${t('footer.label1')} {last} ${t('footer.label2')} {totalRecords}`}
        >
          {rowSelecteds === false || user.range === 3
            ? null
            : (
            <Column
              selectionMode="multiple"
              selectionAriaLabel="name"
              headerStyle={{ width: '3rem' }}
              style={{ height: '5.5rem', textAlign: 'center' }}
              headerClassName="selectionChexbox"
            />
              )}

          {rowStates === false
            ? null
            : (
            <Column
              sortable
              header={t('items.estado')}
              headerStyle={{
                width: '5rem',
                textAlign: 'center'
              }}
              bodyStyle={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                overflow: 'visible',
                justifyContent: 'center'
              }}
              style={{ minWidth: '10rem', height: '5.5rem' }}
              body={states}
            />
              )}
          {columns &&
            columns.map((column) => {
              return (
                <Column
                  key={column.field}
                  field={column.field}
                  header={column.header}
                  headerStyle={{
                    width: '5rem',
                    textAlign: 'center',
                    justifyContent: 'center'
                  }}
                  bodyStyle={{
                    textAlign: 'center',
                    justifyContent: 'center'
                  }}
                  sortable
                  style={{
                    minWidth: '10rem',
                    height: '5.5rem'
                  }}
                />
              )
            })}

          {actionDashboard === false
            ? null
            : (
            <Column
              headerStyle={{
                width: '4rem',
                textAlign: 'center'
              }}
              bodyStyle={{
                textAlign: 'center',
                overflow: 'visible'
              }}
              style={{ height: '5.5rem' }}
              body={dashboard}
            />
              )}
          {viewBtnAction === true
            ? (
            <Column
              headerStyle={{
                width: '4rem',
                textAlign: 'center'
              }}
              bodyStyle={{
                textAlign: 'center',
                overflow: 'visible'
              }}
              style={{ height: '5.5rem' }}
              body={btn}
            />
              )
            : null}
          {link === true
            ? (
            <Column
              headerStyle={{
                width: '4rem',
                textAlign: 'center'
              }}
              bodyStyle={{
                textAlign: 'center',
                overflow: 'visible'
              }}
              style={{ height: '5.5rem' }}
              body={navLink}
            />
              )
            : null}
          {editUsers === false
            ? null
            : (
            <Column
              headerStyle={{
                width: '4rem',
                textAlign: 'center'
              }}
              bodyStyle={{
                textAlign: 'center',
                overflow: 'visible'
              }}
              style={{ height: '5.5rem' }}
              body={editUser}
            />
              )}
          {modifyLists === true
            ? (
            <Column
              headerStyle={{
                width: '4rem',
                textAlign: 'center'
              }}
              bodyStyle={{
                textAlign: 'center',
                overflow: 'visible'
              }}
              style={{ height: '5.5rem' }}
              body={modifyListsSW}
            />
              )
            : null}

          {table === 'geofences' && optionsMenu === true
            ? (
            <Column
              headerStyle={{
                width: '4rem',
                textAlign: 'center'
              }}
              bodyStyle={{
                textAlign: 'center',
                overflow: 'visible'
              }}
              style={{ height: '5.5rem' }}
              body={optionsMenuGeofence}
            />
              )
            : null}

          {table === 'cases'
            ? (
            <Column
              headerStyle={{
                width: '4rem',
                textAlign: 'center'
              }}
              bodyStyle={{
                textAlign: 'center',
                overflow: 'visible'
              }}
              style={{ height: '5.5rem' }}
              body={optionsMenuBlockCases}
            />
              )
            : null}

          {actionDelete === false ||
          (table !== 'blackList' &&
            table !== 'whiteList' &&
            table !== 'suspect' &&
            user.range !== 1)
            ? null
            : (
            <Column
              headerStyle={{
                width: '4rem',
                textAlign: 'center'
              }}
              bodyStyle={{
                textAlign: 'center',
                overflow: 'visible'
              }}
              style={{ height: '5.5rem' }}
              body={deleted}
            />
              )}
        </DataTable>
      </div>
    </div>
  )
}

DataTableDemo.propTypes = {
  searchs: PropTypes.array,
  table: PropTypes.string,
  type: PropTypes.string,
  onSelecteds: PropTypes.func,
  editDataUser: PropTypes.func,
  actionBtn: PropTypes.func,
  titleBtn: PropTypes.string,
  reload: PropTypes.func,
  title: PropTypes.string,
  header: PropTypes.string,
  showMenu: PropTypes.func,
  getFence: PropTypes.func,
  exportsCsv: PropTypes.bool,
  exportsPdf: PropTypes.bool,
  rowSelecteds: PropTypes.bool,
  rowStates: PropTypes.bool,
  actionDashboard: PropTypes.bool,
  actionDelete: PropTypes.bool,
  optionsMenu: PropTypes.bool,
  modifyLists: PropTypes.bool,
  viewBtnAction: PropTypes.bool,
  link: PropTypes.bool,
  columns: PropTypes.array,
  data: PropTypes.array,
  selected: PropTypes.array,
  editUsers: PropTypes.bool,
  informationOptionMenu: PropTypes.bool,
  editOptionMenu: PropTypes.bool,
  columnStatus: PropTypes.array,
  actionBlockCases: PropTypes.func,
  namePdf: PropTypes.string,
  actionDenunciation: PropTypes.func,
  renderHeaderDenunciations: PropTypes.func
}
